import type { CanvasKindCatalog, CanvasKindSize } from '@components/canvas';

import type { DashboardCardItemKind, DashboardWidgetKind } from '../types';

export const DASHBOARD_KIND_CATALOG: Record<DashboardWidgetKind, CanvasKindSize> = {
  card: { defaultColSpan: 4, defaultRowSpan: 4, minColSpan: 2, minRowSpan: 2 },
};

export const DASHBOARD_CANVAS_CATALOG: CanvasKindCatalog = DASHBOARD_KIND_CATALOG;

export const DASHBOARD_MIN_SIZE_BY_KIND = Object.fromEntries(
  (Object.keys(DASHBOARD_KIND_CATALOG) as DashboardWidgetKind[]).map((kind) => [
    kind,
    {
      colSpan: DASHBOARD_KIND_CATALOG[kind].minColSpan,
      rowSpan: DASHBOARD_KIND_CATALOG[kind].minRowSpan,
    },
  ]),
) as Record<DashboardWidgetKind, { readonly colSpan: number; readonly rowSpan: number }>;

export interface CardItemSizing {
  readonly defaultColSpan: number;
  readonly defaultRowSpan: number;
}

export const DASHBOARD_CARD_ITEM_DEFAULT_SIZING: Record<DashboardCardItemKind, CardItemSizing> = {
  metric: { defaultColSpan: 3, defaultRowSpan: 2 },
  chart: { defaultColSpan: 6, defaultRowSpan: 5 },
  text: { defaultColSpan: 6, defaultRowSpan: 2 },
  table: { defaultColSpan: 6, defaultRowSpan: 5 },
  preset: { defaultColSpan: 2, defaultRowSpan: 2 },
};
